import { render } from "./ApthScheduleWidget.vue?vue&type=template&id=3ae8897a"
import script from "./ApthScheduleWidget.vue?vue&type=script&lang=js"
export * from "./ApthScheduleWidget.vue?vue&type=script&lang=js"

import "./ApthScheduleWidget.vue?vue&type=style&index=0&id=3ae8897a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__